document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('[data-westminster-home]');
  if (!root) return;

  const menuButton = root.querySelector('[data-menu-toggle]');
  const menu = root.querySelector('[data-menu]');
  menuButton?.addEventListener('click', () => {
    const open = menu.classList.toggle('is-open');
    menuButton.setAttribute('aria-expanded', String(open));
  });

  menu?.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => {
    menu.classList.remove('is-open');
    menuButton?.setAttribute('aria-expanded', 'false');
  }));

  const tabs = [...root.querySelectorAll('[data-service-tab]')];
  const panels = [...root.querySelectorAll('[data-service-panel]')];
  const visual = root.querySelector('[data-service-visual]');
  const selectTab = (tab) => {
    if (!panels.some((panel) => panel.dataset.servicePanel === tab.dataset.serviceTab)) return;
    tabs.forEach((candidate) => {
      const selected = candidate === tab;
      candidate.setAttribute('aria-selected', String(selected));
      candidate.tabIndex = selected ? 0 : -1;
    });
    panels.forEach((panel) => {
      panel.hidden = panel.dataset.servicePanel !== tab.dataset.serviceTab;
    });
    if (visual) visual.dataset.mode = tab.dataset.serviceTab;
  };
  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => selectTab(tab));
    tab.addEventListener('keydown', (event) => {
      let next;
      if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
      else if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = tabs.length - 1;
      else return;
      event.preventDefault();
      selectTab(tabs[next]);
      tabs[next].focus();
    });
  });
});


(() => {
  const initWestminsterMotion = () => {
    const root = document.querySelector('[data-westminster-home]');
    if (!root || root.dataset.motionReady === 'true') return;
    root.dataset.motionReady = 'true';

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const selectors = [
      '.wg-proof > div',
      '.wg-section-head',
      '.wg-tabs',
      '.wg-service-panel',
      '.wg-location-copy > span',
      '.wg-location-copy > h2',
      '.wg-location-copy > article',
      '.wg-coach',
      '.wg-photography__intro > *',
      '.wg-photography__work',
      '.wg-photography__services > article',
      '.wg-equipment > *',
      '.wg-featured-video__head > *',
      '.wg-featured-video__frame',
      '.wg-final-cta > *'
    ];

    const items = Array.from(root.querySelectorAll(selectors.join(',')));
    items.forEach((element, index) => {
      element.classList.add('wg-reveal');
      if (element.matches('.wg-hero-visual, .wg-photography__work, .wg-featured-video__frame')) {
        element.classList.add('wg-reveal--scale');
      }
      element.style.setProperty('--wg-motion-delay', `${(index % 5) * 70}ms`);
    });

    if (reducedMotion || !('IntersectionObserver' in window)) {
      items.forEach((element) => element.classList.add('wg-in-view'));
      return;
    }

    root.classList.add('wg-motion-ready');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('wg-in-view');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });

    requestAnimationFrame(() => items.forEach((element) => observer.observe(element)));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWestminsterMotion);
  } else {
    initWestminsterMotion();
  }

  document.addEventListener('shopify:section:load', initWestminsterMotion);
})();
